var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-skeleton-loader',{staticClass:"field-data mt-1 mb-0",attrs:{"type":"rect","width":_vm.setSkeletonSize(),"height":_vm.setSkeletonHeight(),"animation":"fade","rounded":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }